/* RN buyer monitor (12 Oct 2026, job j1012-103738-ce65).
   J: "We need tracking on every action and every button ... Nothing ever can go wrong every without us knowing."
   Counts every click, basket call, script error, failed shop image or script, and visible error message.
   Sends through window.rnMeasure (rn-analytics.js): GA4 only, only with analytics consent, never for internal/QA traffic.
   Never reads what a buyer types, never their email, address or photos. Never changes the page or a request. */
(() => {
  try {
    if (window.__rnMonitor) return;
    window.__rnMonitor = 1;
    let sent = 0;
    const MAX = 120; // per page view, so a broken loop cannot flood GA4
    const m = (name, params) => {
      try {
        if (sent >= MAX || typeof window.rnMeasure !== 'function') return;
        sent += 1;
        window.rnMeasure(name, params);
      } catch (_) { /* monitoring must never break the shop */ }
    };
    const clean = (value, max = 90) => String(value == null ? '' : value)
      .replace(/\S+@\S+/g, '[email]')
      .replace(/\d{5,}/g, '[n]')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
    const file = (url) => {
      try {
        const u = new URL(url, location.href);
        return clean(u.host.replace(/^www\./, '') + '/' + (u.pathname.split('/').pop() || ''), 90);
      } catch (_) { return ''; }
    };
    const section = (el) => {
      const s = el && el.closest && el.closest('[id^="shopify-section-"]');
      if (!s) return el && el.closest && el.closest('header') ? 'header' : (el && el.closest && el.closest('footer') ? 'footer' : 'page');
      return clean(s.id.replace(/^shopify-section-/, '').replace(/^template--\d+__/, '').replace(/^sections--\d+__/, ''), 60);
    };
    const label = (el) => {
      const own = el.getAttribute('aria-label') || el.getAttribute('data-rn-label') || el.getAttribute('name') || el.id;
      if (own) return clean(own, 60);
      if (el.tagName === 'INPUT') return clean(el.type === 'submit' ? el.value : el.type, 60);
      return clean(el.textContent, 60);
    };

    // 1. Every tap on a link, button or choice.
    document.addEventListener('click', (event) => {
      try {
        const el = event.target && event.target.closest && event.target.closest('a,button,summary,input[type=submit],input[type=checkbox],input[type=radio],[role=button]');
        if (!el) return;
        m('rn_click', { rn_el: el.tagName.toLowerCase(), cta_label: label(el), module_id: section(el) });
      } catch (_) {}
    }, true);

    // 2. Every basket call: add, change, update, clear. Successful reads are not counted; failed reads are.
    const cartOp = (input) => {
      try {
        const raw = typeof input === 'string' ? input : (input && input.url) || String(input || '');
        const u = new URL(raw, location.href);
        if (u.origin !== location.origin) return null;
        const r = u.pathname.match(/\/cart(?:\/(add|change|update|clear))?(?:\.js)?\/?$/);
        return r ? (r[1] || 'read') : null;
      } catch (_) { return null; }
    };
    const cartDone = (op, status, t0) => {
      const ok = status >= 200 && status < 400;
      if (ok && op === 'read') return;
      m(ok ? 'rn_cart_ok' : 'rn_cart_fail', { rn_op: op, rn_status: status || 'network', rn_ms: Math.round(performance.now() - t0) });
    };
    const nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function rnMonitoredFetch(...args) {
        const pending = nativeFetch.apply(this, args);
        try {
          const op = cartOp(args[0]);
          if (op) {
            const t0 = performance.now();
            pending.then((r) => { try { cartDone(op, r.status, t0); } catch (_) {} }, () => { try { cartDone(op, 0, t0); } catch (_) {} });
          }
        } catch (_) {}
        return pending;
      };
    }
    const X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (X) {
      const open = X.open;
      const send = X.send;
      X.open = function (...args) {
        try { this.__rnCartOp = cartOp(args[1]); } catch (_) {}
        return open.apply(this, args);
      };
      X.send = function (...args) {
        try {
          const op = this.__rnCartOp;
          if (op) {
            const t0 = performance.now();
            this.addEventListener('loadend', () => { try { cartDone(op, this.status, t0); } catch (_) {} }, { once: true });
          }
        } catch (_) {}
        return send.apply(this, args);
      };
    }

    // 3. Script errors, and shop images or scripts that fail to load (blank tiles).
    window.addEventListener('error', (event) => {
      try {
        const t = event.target;
        if (t && t !== window && t.tagName) {
          const src = t.currentSrc || t.src || t.href || '';
          if (/ripleysnest\.|cdn\.shopify\.com|\/cdn\/shop\//.test(src)) {
            m('rn_resource_fail', { rn_kind: t.tagName.toLowerCase(), rn_src: file(src), module_id: section(t) });
          }
          return;
        }
        m('rn_js_error', { rn_kind: 'runtime', rn_src: file(event.filename || ''), rn_msg: clean(event.message) });
      } catch (_) {}
    }, true);
    window.addEventListener('unhandledrejection', (event) => {
      try {
        const r = event.reason;
        m('rn_js_error', { rn_kind: 'promise', rn_msg: clean((r && r.message) || r) });
      } catch (_) {}
    });

    // 4. Error messages a buyer can see (basket, product form, forms).
    const seen = new WeakSet();
    let timer = 0;
    const scan = () => {
      timer = 0;
      try {
        document.querySelectorAll('[role=alert], .product-form__error-message, .cart-errors, .form__message--error, .errors').forEach((el) => {
          if (seen.has(el) || el.hidden || !el.getClientRects().length || !clean(el.textContent)) return;
          seen.add(el);
          m('rn_error_shown', { rn_msg: clean(el.textContent), module_id: section(el) });
        });
      } catch (_) {}
    };
    new MutationObserver(() => { if (!timer) timer = setTimeout(scan, 300); })
      .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
  } catch (_) { /* never break the shop */ }
})();
